export const ADD_CHECKED_WEED = "ADD_CHECKED_WEED";
export const REMOVE_CHECKED_WEED = "REMOVE_CHECKED_WEED";
export const SET_WEEDS = "SET_WEEDS";
export const CLEAR_WEEDS = "CLEAR_WEEDS";
